export default "__VITE_ASSET__CkFHZt0i__"